import { useCallback, useRef } from "react";

export type ContextedFunction<
	ContextType = unknown,
	Parameters extends unknown[] = unknown[],
	ReturnType = unknown,
> = (this: ContextType, ...args: Parameters) => ReturnType;
export type ContextSetter<ContextType = unknown> = (
	context: ContextType,
) => void;

export default function useContextedFunction<
	ContextType,
	Parameters extends unknown[],
	ReturnType,
>(
	callback: ContextedFunction<ContextType, Parameters, ReturnType>,
	defaultContext: ContextType,
) {
	const contextRef = useRef<ContextType>(defaultContext);

	const contextedFunction = useCallback(
		(...args: Parameters) => callback.apply(contextRef.current, args),
		[],
	);

	return [
		contextedFunction,
		useCallback((context: ContextType) => {
			contextRef.current = context;
		}, []),
	] as [typeof contextedFunction, ContextSetter<ContextType>];
}
